export const TYPE = 'selected';
